import { render, staticRenderFns } from "./ReportTabGroupMealsTabGroupedShiftMeals.vue?vue&type=template&id=245c2480"
import script from "./ReportTabGroupMealsTabGroupedShiftMeals.vue?vue&type=script&lang=js"
export * from "./ReportTabGroupMealsTabGroupedShiftMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports